/**
 * Auto-Detect Size Chart JavaScript
 * Simplified version that only handles unit toggle
 */

(function() {
  // Initialize the size chart functionality when the DOM is fully loaded
  document.addEventListener('DOMContentLoaded', function() {
    initSizeChart();
  });

  function initSizeChart() {
    // Get the button and popup elements
    // const sizeChartButton = document.getElementById('size-chart-button');
    const sizeChartButtons = document.querySelectorAll('.size-chart-button');
    const sizeChartPopup = document.getElementById('size-chart-popup');
    const closeButton = document.querySelector('.close-button');
    
    // Get unit toggle element
    const unitToggle = document.getElementById('unit-toggle-checkbox');
    
    // Exit if elements aren't found (size chart not on page)
    // if (!sizeChartButton || !sizeChartPopup || !closeButton) {
    //   console.log('Size chart elements not found, skipping initialization.');
    //   return;
    // }
    
    if (sizeChartButtons.length === 0 || !sizeChartPopup || !closeButton) {
      console.log('Size chart elements not found, skipping initialization.');
      return;
    }
    
    // Open the popup when the button is clicked
    // sizeChartButton.addEventListener('click', function(event) {
    //   event.preventDefault();
    //   sizeChartPopup.style.display = 'block';
    //   document.body.style.overflow = 'hidden'; // Prevent scrolling when popup is open
    // });
    
    sizeChartButtons.forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        sizeChartPopup.style.display = 'block';
        document.body.style.overflow = 'hidden'; // Prevent scrolling when popup is open
      });
    });
    
    // Close the popup when the close button is clicked
    closeButton.addEventListener('click', function() {
      sizeChartPopup.style.display = 'none';
      document.body.style.overflow = ''; // Restore scrolling
    });
    
    // Close the popup when clicking outside of the content
    window.addEventListener('click', function(event) {
      if (event.target === sizeChartPopup) {
        sizeChartPopup.style.display = 'none';
        document.body.style.overflow = ''; // Restore scrolling
      }
    });
    
    // Handle unit toggle
    if (unitToggle) {
      unitToggle.addEventListener('change', function() {
        // Toggle between inches and cm tables
        const inchTables = document.querySelectorAll('[id$="-inches"]');
        const cmTables = document.querySelectorAll('[id$="-cm"]');
        
        inchTables.forEach(table => {
          table.style.display = this.checked ? 'none' : 'table';
        });
        
        cmTables.forEach(table => {
          table.style.display = this.checked ? 'table' : 'none';
        });
      });
    }
    
    // Close with escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && sizeChartPopup.style.display === 'block') {
        sizeChartPopup.style.display = 'none';
        document.body.style.overflow = ''; // Restore scrolling
      }
    });
  }
})();